import React from 'react';
import {
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuList,
} from '@chakra-ui/react';
import { FiMoreHorizontal, FiMoreVertical } from 'react-icons/fi';
import { Sinisters, SinistersView } from '~/types/sinisters';
import { SinistersEvaluateForm } from '~/pages/Portal/Sinisters/SinistersEvaluateForm';
import { SinistersPolicyForm } from '~/pages/Portal/Sinisters/SinistersPolicy/SinistersPolicyForm';
import { SinistersInsurerForm } from '~/pages/Portal/Sinisters/SinistersInsurerForm';
import { SinistersDebitNoteForm } from '~/pages/Portal/Sinisters/SinistersDebitNote/SinistersDebitNoteForm';
import { SinistersEvaluatePaymentForm } from '~/pages/Portal/Sinisters/SinistersEvaluatePaymentForm';
import { SinistersCloseForm } from '~/pages/Portal/Sinisters/SinistersCloseForm';
import { SinistersCancelForm } from '~/pages/Portal/Sinisters/SinistersCancelForm';
import { SinistersForm } from '~/pages/Portal/Sinisters/SinistersForm';
import { SinistersDownloadDebitNote } from '~/pages/Portal/Sinisters/SinistersDownloadDebitNote';
import { SinistersProvePaymentForm } from '~/pages/Portal/Sinisters/SinistersProvePaymentForm';
import { useQueryParams, useRoleCan } from '~/hooks';

export const SinistersMenuOptions: React.FC<{
  sinistro: Sinisters | SinistersView;
  isDetail?: boolean;
}> = ({ sinistro, isDetail }) => {
  const userIsAdminOrTechinician = useRoleCan({
    roles: ['administrador', 'técnico'],
  });
  const userIsAdmin = useRoleCan({ roles: ['administrador'] });
  const userIsClient = useRoleCan({ roles: ['cliente'] });

  const query = useQueryParams();
  const disabledMenu = () => {
    if (userIsClient) {
      return (
        !sinistro.pode_revisar_comunicado && !sinistro.pode_comprovar_pagamento
      );
    }
    if (userIsAdmin) {
      return (
        sinistro.status === 8 ||
        sinistro.status === 9 ||
        (!sinistro.pode_encerrar && !sinistro.pode_cancelar)
      );
    }
    return !sinistro.pode_enviar_nota_de_debito;
  };
  return (
    <>
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          p={0}
          style={{
            borderColor: 'transparent',
            background: 'none',
          }}
          _hover={{
            borderColor: 'transparent',
            background: 'none',
          }}
          icon={
            !isDetail ? (
              <Icon as={FiMoreVertical} fontSize="xl" />
            ) : (
              <Icon as={FiMoreHorizontal} fontSize="xl" />
            )
          }
          variant="outline"
          isDisabled={disabledMenu()}
        />
        {userIsAdminOrTechinician && (
          <MenuList>
            {(sinistro?.status === 11 || sinistro?.status === 0) &&
              userIsAdmin && (
                <SinistersEvaluateForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'EVALUATE'}
                />
              )}
            {(sinistro?.status === 11 || sinistro?.status === 0) &&
              userIsAdmin && <MenuDivider />}
            {sinistro?.pode_registrar_apolice_seguro && userIsAdmin && (
              <>
                <SinistersPolicyForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'REGISTER-POLICY'}
                />
                <MenuDivider />
              </>
            )}
            {sinistro?.pode_enviar_a_seguradora && userIsAdmin && (
              <>
                <SinistersInsurerForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'SEND-INSURER'}
                />
                <MenuDivider />
              </>
            )}
            {sinistro?.pode_enviar_nota_de_debito &&
              userIsAdminOrTechinician && (
                <SinistersDebitNoteForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'DEBIT-NOTE'}
                />
              )}
            {sinistro?.pode_enviar_nota_de_debito && userIsAdmin && (
              <MenuDivider />
            )}
            {sinistro?.pode_avaliar_pagamento && userIsAdmin && (
              <>
                <SinistersEvaluatePaymentForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'EVALUATE-PAYMENT'}
                />
                <MenuDivider />
              </>
            )}
            {sinistro?.pode_encerrar && userIsAdmin && (
              <SinistersCloseForm
                sinisterId={sinistro?.id}
                link={isDetail && query.get('modal') === 'CLOSE'}
              />
            )}
            {sinistro?.pode_cancelar && userIsAdmin && (
              <SinistersCancelForm sinisterId={sinistro?.id} />
            )}
          </MenuList>
        )}
        {userIsClient && (
          <MenuList>
            {sinistro?.pode_revisar_comunicado && (
              <SinistersForm
                isEdit
                sinisterId={sinistro?.id}
                link={isDetail && query.get('modal') === 'EDIT'}
              />
            )}
            {(sinistro?.pode_comprovar_pagamento ||
              sinistro?.pode_revisar_pagamento) && (
              <>
                {sinistro?.pode_baixar_nota_de_debito && (
                  <SinistersDownloadDebitNote sinisterId={sinistro?.id} />
                )}
                <SinistersProvePaymentForm
                  sinisterId={sinistro?.id}
                  link={isDetail && query.get('modal') === 'PAYMENT'}
                />
              </>
            )}
          </MenuList>
        )}
      </Menu>
    </>
  );
};
